import $http from '@/libs/axios'

export default class AdminStatisticsApi {
  static async statistics(data: any) {
    return (await $http.post('admin/statistics', data)).data
  }
}
